<template>
  <div class="d-flex justify-center">
    <v-btn icon color="primary" @click="viewEntries">
      <v-icon>mdi-eye</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  methods: {
    viewEntries() {
      this.params.context.parentComponent.viewDateEntries(this.params.data.date);
    },
  },
};
</script>
